/**
 * Whether a member's referral tag marks them as a domestic-abuse referral.
 *
 * The comparison is case-insensitive on purpose: the tag arrives from the
 * `?tag=` link on the register page and is stored verbatim, so both 'DA' and
 * 'da' exist in the members table. A strict === 'DA' silently skips the latter.
 */
export function isDomesticAbuseTag(tag: string | null | undefined): boolean {
    return (tag ?? '').trim().toUpperCase() === 'DA';
}
